<template>
  <div>
    <div class="flex-x-center">
      <div class="profile-content">
        <div id="printTicketTable" :style="`margin:0 auto;width:${pdfWidth};`">
          <canvas v-for="page in pdfPages" :key="page" :id="'pdfCanvasTicket' + page"></canvas>
        </div>
      </div>
      <!-- <div id="exportPdf" ref="exportPdf">8888</div> -->
    </div>

    <div class="flex-x-center agree-sign-next">
      <button class="next-step" @click="download()">下载打印</button>
      <button class="next-step" @click="$parent.next()">下一步</button>
    </div>
  </div>
</template>
<script>
import { getApplyFile } from "@/api";
import { mapState } from "pinia";
import { useMainStore } from "@/store/piniaStore";
const PDFJS = require("pdfjs-dist");
PDFJS.GlobalWorkerOptions.workerSrc =
  "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.5.207/pdf.worker.js";
export default {
  data() {
    return {
      pdfPages: [], // 页数
      pdfWidth: "", // 宽度
      pdfSrc: "", // 地址
      pdfDoc: "", // 文档内容
      pdfScale: 1.5, // 放大倍数
    };
  },
  props: {
    // 流程
    process_index: 0,
    process: {
      type: Object,
      default() {
        return [];
      },
    },
  },
  computed: {
    ...mapState(useMainStore, {
      projectDetail: "getProjectDetail",
      userCertInfo: "getUserCertInfo",
    }),
  },
  mounted() {
    if (this.process.name === this.$parent.step_name) {
      this.getPdfUrl();
    }
  },
  methods: {
    download() {
      window.open(this.pdfSrc);
    },
    getPdfUrl() {
      // todo 请求后台，获取pdf的url，这里用的是线上的地址
      getApplyFile({ project_id: this.projectDetail.project_info.id })
        .then((res) => {
          if (res.data.code == 1) {
            // 将完整URL转为相对路径，通过dev proxy避免CORS
            let fileUrl = res.data.data.file;
            try {
              let urlObj = new URL(fileUrl);
              fileUrl = urlObj.pathname;
            } catch (e) {}
            this.pdfSrc = fileUrl;
            this.loadFile(this.pdfSrc);
          }
        })
        .catch((err) => { });
    },
    loadFile(url) {
      let loadingTask = PDFJS.getDocument(url);
      loadingTask.promise.then((pdf) => {
        this.pdfDoc = pdf;
        this.pdfPages = pdf.numPages;
        this.$nextTick(() => {
          this.renderPage(1);
        });
      });
    },
    renderPage(num) {
      const that = this;
      this.pdfDoc.getPage(num).then((page) => {
        let canvas = document.getElementById("pdfCanvasTicket" + num);
        let ctx = canvas.getContext("2d");
        let dpr = window.devicePixelRatio || 1;
        let bsr =
          ctx.webkitBackingStorePixelRatio ||
          ctx.mozBackingStorePixelRatio ||
          ctx.msBackingStorePixelRatio ||
          ctx.oBackingStorePixelRatio ||
          ctx.backingStorePixelRatio ||
          1;
        let ratio = dpr / bsr;
        let viewport = page.getViewport({ scale: this.pdfScale });
        canvas.width = viewport.width * ratio;
        canvas.height = viewport.height * ratio;

        canvas.style.width = viewport.width + "px";

        that.pdfWidth = viewport.width + "px";

        canvas.style.height = viewport.height + "px";

        ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
        // 将 PDF 页面渲染到 canvas 上下文中
        let renderContext = {
          canvasContext: ctx,
          viewport: viewport,
        };
        page.render(renderContext);
        if (this.pdfPages > num) {
          this.renderPage(num + 1);
        }
      });
    },
  },
};
</script>
<style>
.preview-pdf {
  h1 {
    margin: 30px auto;
    text-align: center;
    font-family: "宋体";
    letter-spacing: 2px;
  }
}
</style>
